import ExportIcon from "../../../../../assets/icons/export.svg";
import EyeIcon from "../../../../../assets/icons/fi-eye.svg";
import { formatCurrency } from "../../utils/money";
import Button from "../../../components/Button";

const SelectedServicesFooter = ({
    vatPercent,
    vatLoading,
    subtotal,
    vat,
    total,
    exporting,
    previewing,
    onExport,
    onPreview,
    disabled,
}) => {
    return (
        <div className="border-t border-[#E3E3E3] shrink-0 px-3 pb-4 pt-3 bg-white rounded-bl-lg rounded-br-lg md:px-4">
            <div className="space-y-1 sm:space-y-2 my-2 sm:my-4">
                <div className="flex justify-between text-xs sm:text-sm text-gray-700">
                    <span>Tạm tính</span>
                    <span>{formatCurrency(subtotal)}</span>
                </div>

                {vat > 0 && (
                    <div className="flex justify-between text-xs sm:text-sm text-gray-700">
                        <span>
                            Thuế GTGT (VAT)
                        </span>
                        <span>{formatCurrency(vat)}</span>
                    </div>
                )}

                <div className="border-t border-dashed border-gray-300 my-1 sm:my-2" />

                <div className="flex justify-between items-center">
                    <span className="text-base sm:text-lg font-semibold text-gray-800">
                        Tổng thanh toán
                    </span>
                    <span className="text-xl sm:text-2xl font-semibold text-[#0267FF]">
                        {formatCurrency(total)}
                    </span>
                </div>
            </div>

            <div className="grid grid-cols-2 gap-3 mt-4">
                <Button
                    type="button"
                    variant="secondary"
                    size="lg"
                    onClick={onPreview}
                    disabled={disabled || previewing || exporting}
                    isLoading={previewing}
                    className="w-full"
                    leftIcon={
                        <img src={EyeIcon} alt="" className="w-4 h-4 sm:w-5 sm:h-5 shrink-0 opacity-70" />
                    }
                >
                    {previewing ? "Đang tải..." : "Xem trước"}
                </Button>

                <Button
                    type="button"
                    variant="secondary"
                    size="lg"
                    onClick={onExport}
                    disabled={disabled || exporting || previewing}
                    isLoading={exporting}
                    className="w-full"
                    leftIcon={
                        <img src={ExportIcon} alt="" className="w-4 h-4 sm:w-5 sm:h-5 shrink-0" />
                    }
                >
                    {exporting ? "Đang xuất..." : "Xuất file PDF"}
                </Button>
            </div>
        </div>
    );
};

export default SelectedServicesFooter;
